module.exports = __webpack_public_path__ + "img/Itau.c89ddd00.svg";